import { Form, Formik } from "formik";
import style from "./CreatePromoCode.module.scss"
import { Button, Input, InputSelect } from "@ui";
import * as Yup from 'yup';
import { useCreatePromoCodeMutation } from "@RTKQuery/admin/promoCodes/promoCodes";
import { EPromoCode } from "@interfaces/promoCode.enum";

const listType = [
    {
        label: EPromoCode.percentage,
        value: "percentage"
    },
    {
        label: EPromoCode.amount,
        value: "amount"
    }
]

export function CreatePromoCode() {
    const [createPromoCode, { isSuccess, isLoading, error, reset }] = useCreatePromoCodeMutation();

    return (
        <div className={style.container}>
            <p className={style.label}>Створення нового промокоду</p>
            <Formik
                initialValues={{
                    namePromo: '',
                    type: 'percentage',
                    bonuses: '',
                    amount: '',
                    quantity: ''
                }}
                validationSchema={Yup.object({
                    namePromo: Yup.string()
                        .required("Назва промокоду - обов'язкове поле"),
                    bonuses: Yup.number().typeError("Тільки числа ")
                        .max(100, "Максимум 100%")
                        .min(1, "Мінімум 1%")
                        .test(
                            "is-req",
                            "Розмір бонусів - обов'язкове поле",
                            (value, context) => {
                                if (context.parent.type === "percentage") {
                                    return Boolean(value)
                                } else {
                                    return true;
                                }
                            },
                        ),
                    amount: Yup.number().typeError("Тільки числа ")
                        .min(1, "Мінімум 1$")
                        .test(
                            "is-req",
                            "Сума на баланс - обов'язкове поле",
                            (value, context) => {
                                if (context.parent.type === "amount") {
                                    return Boolean(value)
                                } else {
                                    return true;
                                }
                            },
                        ),
                    quantity: Yup.number().typeError("Тільки числа ")
                        .required("Кількість - обов'язкове поле"),
                })}
                onSubmit={(values, actions) => {
                    if (values.type === "percentage") {
                        createPromoCode({
                            type: EPromoCode.percentage,
                            code: values.namePromo,
                            bonus: Number(values.bonuses),
                            quantity: Number(values.quantity) || 0
                        })
                    } else {
                        createPromoCode({
                            type: EPromoCode.amount,
                            code: values.namePromo,
                            bonus: Number(values.amount),
                            quantity: Number(values.quantity) || 0
                        })
                    }
                }}
            >
                {props => (
                    <Form>
                        <Input
                            label="Назва промокоду"
                            type="text"
                            onChange={(newValue) => {
                                props.setFieldValue("namePromo", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={props.values.namePromo}
                            name="namePromo"
                            customStyle={{
                                width: style.customInput
                            }}
                            error={props.touched.namePromo ? props.errors.namePromo : ""}
                        />
                        <InputSelect
                            label="Тип"
                            name="type"
                            currentValue={listType.find(item => item.value === props.values.type) || listType[0]}
                            onChange={(newValue) => {
                                props.setFieldValue("type", newValue.value)
                            }}
                            listValues={listType}
                            customStyle={{
                                container: style.customInput
                            }}
                            onBlur={props.handleBlur}
                            error={props.touched.type ? props.errors.type : ""}
                        />
                        {
                            props.values.type === "percentage"
                                ? <Input
                                    label="Розмір бонусів"
                                    type="text"
                                    onChange={(newValue) => {
                                        props.setFieldValue("bonuses", newValue.trim())
                                    }}
                                    onBlur={props.handleBlur}
                                    value={String(props.values.bonuses)}
                                    name="bonuses"
                                    customStyle={{
                                        width: style.customInput
                                    }}
                                    error={props.touched.bonuses ? props.errors.bonuses : ""}
                                />
                                : null
                        }
                        {
                            props.values.type === "amount"
                                ? <Input
                                    label="Сума на баланс"
                                    type="text"
                                    onChange={(newValue) => {
                                        props.setFieldValue("amount", newValue.trim())
                                    }}
                                    onBlur={props.handleBlur}
                                    value={String(props.values.amount)}
                                    name="amount"
                                    customStyle={{
                                        width: style.customInput
                                    }}
                                    error={props.touched.amount ? props.errors.amount : ""}
                                />
                                : null
                        }
                        <Input
                            label="Кількість"
                            type="text"
                            onChange={(newValue) => {
                                props.setFieldValue("quantity", newValue.trim())
                            }}
                            onBlur={props.handleBlur}
                            value={String(props.values.quantity)}
                            name="quantity"
                            customStyle={{
                                width: style.customInput
                            }}
                            error={props.touched.quantity ? props.errors.quantity : ""}
                        />
                        <Button
                            type="submit"
                            text="Створити"
                            color="orange"
                            form="ellipse"
                            customStyle={{
                                button: "!w-[160px] !h-[42px] max-sm:mx-auto"
                            }}
                            successContent={
                                isSuccess
                                    ? {
                                        title: "Вітаємо!",
                                        description: <p className="max-w-[260px]">Ви успішно створили промокод!</p>
                                    }
                                    : undefined
                            }
                            loading={isLoading}
                            errors={[
                                (error && ((extractError) => {
                                    return extractError(error)
                                }))
                            ]}
                            resetStatus={() => {
                                reset();
                                props.resetForm()
                            }}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    )
}